import { render } from "./ButtonDemo.vue?vue&type=template&id=4f05a9f7"
import script from "./ButtonDemo.vue?vue&type=script&lang=js"
export * from "./ButtonDemo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dongjoosong/Code/poseidon-vue-1.0.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__